export type NewMaterialTypeRequest = {
  "name": string;
}
export type MaterialTypeItemData = {
  "@id": string;
  "@type": string;
  "name": string;
  "id": number;
}

export type MaterialTypePagination = {
  "@id": string;
  "type": string;
  "first": string;
  "last": string;
  "previous": string;
  "next": string;
}

export type MaterialTypeSearchMappingItem = {
  "@type": string;
  "variable": string;
  "property": string;
  "required": boolean;
}

export type MaterialTypeSearch = {
  "@type": string;
  "template": string;
  "variableRepresentation": string;
  "mapping": MaterialTypeSearchMappingItem[]
}

export type MaterialTypeListResponse = {
  "member": MaterialTypeItemData[],
  "totalItems": number;
  "view": MaterialTypePagination;
  "search": MaterialTypeSearch;
}

export type MaterialTypePageState = {
  page: number;
  pagination: boolean;
  name?: string | null;
  q?: string | null;
  'order'?: {dataKey: string; order?: "asc" | "desc"};
}

export type MaterialTypeListStateType = {
  pageState: MaterialTypePageState,
  setPageState: (state: MaterialTypePageState) => void;
}

export const initialMaterialTypePageState: MaterialTypePageState = {
  page: 1,
  pagination: true,
  'order': {dataKey: 'id', order: "desc"},
}
